// Decodes a URL-safe base64 string back to a UTF-8 string.
// Returns null if the value is missing or cannot be decoded.
const decodeBase64Param = (value) => {
  if (!value) return null;
  try {
    let normalized = value.replace(/-/g, '+').replace(/_/g, '/');
    while (normalized.length % 4) normalized += '=';

    const binary = atob(normalized);
    const bytes = Uint8Array.from(binary, (ch) => ch.charCodeAt(0));
    return new TextDecoder('utf-8').decode(bytes);
  } catch (e) {
    return null;
  }
};

export default decodeBase64Param;
